import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ThemeContainer from '@shorelight/ui-common-components/cjs/themes/ThemeContainer';

//@ts-ignore
import { UploaderContextProvider } from '@shorelight/super-form/components/FileUploaderWithContext';

import { ApplicationState } from '../../store/types';
import { getFormSchema, continueToForm } from '../../store/wizard/actions';
import {
  selectFiles,
  uploadFile,
  selectSingleFile,
  removeSingleFile,
  removeFile
} from '../../store/upload/actions';

import SuccessPage from '../SuccessPage/SuccessPage';
import FormContainer from '../FormContainer/FormContainer';
import { customThemeStyles } from '../../styles/materialTheme';

import { WizardContainerProps } from './WizardContainer.propTypes';

import WelcomePage from '../WelcomePage/WelcomePage';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

export const WizardContainer: React.FC<WizardContainerProps> = (
  props: WizardContainerProps
) => {
  const {
    getForm,
    continueForm,
    continueWithForm,
    fetchingForm,
    submitted,
    confirmationNumber,
    uploading,
    uploadError,
    selectedFiles,
    uploadedFiles,
    handleFileUpload,
    handleRemoveFile,
    handleSelectFiles,
    handleSelectSingleFile,
    handleRemoveSingleFile
  } = props;

  const UploaderContext = {
    uploading,
    uploadError,
    selectedFiles,
    uploadedFiles,
    handleFileUpload,
    handleRemoveFile,
    handleSelectFiles,
    handleSelectSingleFile,
    handleRemoveSingleFile
  };

  useEffect(() => {
    getForm();
  }, [getForm]);

  const getContent = () => {
    if (fetchingForm) {
      return <LoadingIndicator />;
    }
    if (!continueForm) {
      return (
        <div data-testid={'welcome-page'}>
          <WelcomePage onContinue={continueWithForm} />
        </div>
      );
    }
    if (submitted) {
      return (
        <div data-testid={'success-page'}>
          <SuccessPage confirmationNumber={confirmationNumber} />
        </div>
      );
    } else {
      return (
        <div data-testid={'form-container'}>
          <FormContainer />
        </div>
      );
    }
  };

  return (
    <ThemeContainer theme={customThemeStyles}>
      <UploaderContextProvider value={UploaderContext}>
        {getContent()}
      </UploaderContextProvider>
    </ThemeContainer>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    continueForm: state.wizard.continueWithForm,
    fetchingForm: state.wizard.loading,
    submitted: state.wizard.submitted,
    confirmationNumber: state.wizard.confirmationNumber,
    uploading: state.uploader.uploading,
    uploadError: state.uploader.uploadError,
    selectedFiles: state.uploader.selectedFiles,
    uploadedFiles: state.uploader.uploadedFiles
  };
};

const mapDispatchToProps = {
  getForm: getFormSchema,
  handleFileUpload: uploadFile,
  handleSelectFiles: selectFiles,
  handleRemoveFile: removeFile,
  handleSelectSingleFile: selectSingleFile,
  handleRemoveSingleFile: removeSingleFile,
  continueWithForm: continueToForm
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardContainer);
